module.exports = __webpack_public_path__ + "static/media/galleryGT (7).183d7c91.jpg";